import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const productHierarchyResolver: FieldResolver = (metadata: Metadata) => {
  let productHierarchy: string | undefined

  if (metadata.getDocHierarchy() !== undefined) {
    productHierarchy = ''
    metadata.getDocHierarchy()!.entries!.forEach((entry, index) => {
      if (index > 0) {
        productHierarchy += ' <br> '
      }

      if (entry.key) {
        productHierarchy += `${entry.key}=${entry.values!.join(' ; ')}`
      } else {
        productHierarchy += entry.values!.join(' ; ')
      }
    })
  }

  return { productHierarchy } as StreamData
}
export default productHierarchyResolver
